import Web3 from 'web3';
import { createContract, fetchContracts } from './contractsRegistryService';
import configJson from '../config/config.json';
import { wait } from './utilsService';
import { getValueByMultiProps } from '../utils/mapper';
import { getAccount } from './walletService';
import { Erc20 } from '../config/contracts.json';
import { findNetworkById } from '../redux/actions/walletActions';
// used to read data from contract
let contracts = null;

// window.chainId = configJson.network;

const getContracts = async () => {
  contracts = await fetchContracts();
  // Not sure if you want to add BUSD contract like this Mo, i may have missed a simpler way to access busd balance
  contracts.BUSD = {
    abi: Erc20.abi,
    networks: {
      [configJson.network]: {
        Proxy: configJson.busd,
      },
    },
  };

  contracts.Erc20 = {
    abi: Erc20.abi,
    networks: {
      [configJson.network]: {
        Proxy: configJson.busd,
      },
    },
  };

  window.contracts = contracts;
};

getContracts();

const loadContracts = async () => {
  if (!window.contracts) {
    await wait(150);
    loadContracts();
    return;
  }
  return window.contracts;
};

const findInContracts = (contractName) => {
  let newContractsObject = {};

  Object.entries(contracts).forEach(([key, value]) => {
    const newKey = key.toLocaleLowerCase();
    newContractsObject = { ...newContractsObject, [newKey]: value };
  });

  const lowerCasedName = contractName.toLocaleLowerCase();
  return newContractsObject?.[lowerCasedName];
};

export const createNewContract = (name, address) => async () => {
  const contract = findInContracts(name, contracts);
  return new window._web3.eth.Contract(contract.abi, address);
};

export const getContractAddress = async (contractName, network = configJson.network) => {
  if (!window.contracts) {
    await wait(150);
    return getContractAddress(contractName);
  }
  const contract = findInContracts(contractName);
  const contractAddress = getValueByMultiProps(contract?.networks?.[network], ['Proxy', 'address']);
  return contractAddress;
};

export const useContractReader = async (
  contractName,
  contractFunction,
  parameters = [],
  callMethod = (contractInstance) => contractInstance?.methods?.[contractFunction](...parameters)?.call(),
  passedAddress,
) => {
  await loadContracts();

  const contractAddress = passedAddress || (await getContractAddress(contractName));
  const _contract = await createContract(contractName, contractAddress, contracts);
  const contract = await _contract();
  const result = await callMethod(contract);
  return result;
};

window.useContractReader = useContractReader;

export const getContractInstance = async (contractName, passedAddress) => {
  if (!window.contracts) {
    await wait(150);
    return getContractInstance(contractName, passedAddress);
  }
  const foundContract = findInContracts(contractName);
  const network = window.chainId || configJson.network;
  const address =
    passedAddress ||
    getValueByMultiProps(foundContract?.networks?.[network || configJson.network], ['Proxy', 'address']);

  const _contract = await createContract(contractName, address, contracts);
  const contract = await _contract();

  return contract;
};

export const newContractReader = async ({
  contractName,
  functionName = '',
  params = [],
  contractAddress: passedContractAddress, // could be passed in cases like HPool contract
  sendParams, // like from and value that are passed to send function
  onTxHash = () => {}, // could be extended to events param in Future
  chainId = configJson.network || window.chainId, // you only have to pass chain id in (pool list page) like cases when there is multible pools from different networks,
  // otherwise will enforce user to switch
}) =>
  new Promise(async (resolve, reject) => {
    await loadContracts();
    const contractObj = findInContracts(contractName, contracts);
    const { abi, networks } = contractObj;
    const targetAddress = passedContractAddress || getValueByMultiProps(networks[chainId], ['Proxy', 'address']);

    // const networkInfo = findNetworkById(chainId) || {};
    // const { rpcUrl, web3Instance = new Web3(rpcUrl) } = networkInfo; // no need for this step since window._web3 is updated at network switch

    const contractInstance = new window._web3.eth.Contract(abi, targetAddress);

    try {
      if (!sendParams) {
        const result = await contractInstance.methods?.[functionName]?.(...params).call();
        resolve(result);
      } else {
        contractInstance.methods?.[functionName]?.(...params)
          .send({ ...sendParams })
          .once('receipt', (rec) => resolve(rec))
          .once('transactionHash', onTxHash)
          .on('error', (err) => reject(err));
      }
    } catch (error) {
      console.log({ __: error });
      reject(error.message);
    }
  });

window.newContractReader = newContractReader;

export const HORD_TOKEN_ADDRESS = '';
